export enum ClosingDayTypeEnum {
  Automatic = 'Automatico',
  Manual = 'Manual',
}